import { useRef, useState } from 'react';

function legacyCopy(text: string): boolean {
  const ta = document.createElement('textarea');
  ta.value = text;
  ta.setAttribute('readonly', '');
  ta.style.position = 'fixed';
  ta.style.opacity = '0';
  document.body.appendChild(ta);
  ta.select();
  ta.setSelectionRange(0, text.length);
  let ok: boolean;
  try {
    ok = document.execCommand('copy');
  } catch {
    ok = false;
  }
  ta.remove();
  return ok;
}

/**
 * 복사 버튼. 텍스트는 클릭 전에 준비되어 있어야 한다 (iPhone Safari는 클릭 직후 동기 호출만 허용).
 * 복사가 막히면 직접 선택해 복사할 수 있도록 텍스트 상자를 보여준다.
 */
export function CopyButton({
  text,
  label,
  className,
  onCopied,
  disabled,
}: {
  text: string;
  label: string;
  className?: string;
  onCopied?: () => void;
  disabled?: boolean;
}) {
  const [state, setState] = useState<'idle' | 'copied' | 'manual'>('idle');
  const boxRef = useRef<HTMLTextAreaElement>(null);
  const done = () => {
    setState('copied');
    onCopied?.();
    setTimeout(() => setState((s) => (s === 'copied' ? 'idle' : s)), 2000);
  };
  const click = () => {
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(text).then(done, () => (legacyCopy(text) ? done() : setState('manual')));
    } else if (legacyCopy(text)) done();
    else setState('manual');
  };
  return (
    <>
      <button type="button" className={className} onClick={click} disabled={disabled || !text}>
        {state === 'copied' ? '복사됨 ✓' : label}
      </button>
      {state === 'manual' && (
        <div className="stack">
          <p className="warn small">자동 복사가 막혔습니다. 아래 내용을 길게 눌러 전체 선택 후 복사하세요.</p>
          <textarea
            ref={boxRef}
            aria-label="복사할 내용"
            readOnly
            rows={6}
            value={text}
            onFocus={(e) => e.currentTarget.select()}
          />
          <button type="button" onClick={() => (onCopied?.(), setState('idle'))}>
            복사했어요
          </button>
        </div>
      )}
    </>
  );
}
